export const testimonials = [
  {
    name: 'Marcelo G.',
    age: 47,
    role: 'Electricista matriculado · Rosario, Santa Fe',
    topic: 'Diagnóstico de fallas',
    quote:
      'Tuve un caso de un diferencial que saltaba solo cuando el cliente encendía el lavarropas y no le encontraba la vuelta. En el Tomo 1 hay un caso casi igual: síntomas, posibles causas y cómo descartar cada una. Lo usé como guía, medí aislamiento y terminó siendo la resistencia del lavarropas. Me ahorró una tarde entera de prueba y error.',
  },
  {
    name: 'Diego F.',
    age: 38,
    role: 'Electricista domiciliario · La Plata, Buenos Aires',
    topic: 'Instalaciones antiguas',
    quote:
      'En La Plata me tocan muchas casas viejas con cables de tela, empalmes dentro de la pared y circuitos que nadie sabe a dónde van. Los casos del Tomo 3 me ordenaron la cabeza: ahora arranco siempre por el relevamiento y no por cambiar cosas a ciegas. Le explico mejor al cliente qué encontré y por qué hay que corregirlo.',
  },
  {
    name: 'Sergio A.',
    age: 52,
    role: 'Instalador eléctrico · Córdoba Capital',
    topic: 'Presupuestos profesionales',
    quote:
      'Hace más de veinte años que trabajo y siempre presupuestaba "a ojo". Con las planillas del Bono 4 armé un modelo con materiales, mano de obra y condiciones. Lo mando en PDF y los clientes lo ven mucho más serio. Ya no me olvido de cobrar los materiales chicos que antes regalaba sin darme cuenta.',
  },
  {
    name: 'Lucas R.',
    age: 29,
    role: 'Electricista independiente · Godoy Cruz, Mendoza',
    topic: 'Organización del trabajo',
    quote:
      'Arranqué solo hace un par de años y lo que más me costaba era documentar. Las fichas de inspección del Bono 3 las tengo impresas en la camioneta: anoto mediciones, lo que encontré y lo que reparé. Cuando el cliente vuelve a llamar sé exactamente qué se hizo. Los diagramas del Bono 1 también me sirven para repasar antes de un tablero.',
  },
  {
    name: 'Gabriela S.',
    age: 34,
    role: 'Técnica electricista · Neuquén Capital',
    topic: 'Material completo',
    quote:
      'Lo compré pensando que iba a ser otro manual teórico, pero son casos concretos. Lo consulto desde el celular en la obra, sobre todo el manual de mediciones para chequear si un valor de aislamiento o una caída de tensión es razonable. Entre los cuatro tomos y los bonos tengo casi todo lo que necesito en un solo lugar.',
  },
];
